module.exports = "<input type=\"text\" [textMask]=\"maskSettings\" [(ngModel)]=\"usernameModel\" class=\"username-field-js\" [ngClass]=\"classList\"\n  [placeholder]=\"placeholder ? placeholder : 'Логин (Ваш мобильный телефон)'\"\n  (keyup)=\"onKeyUpMask();onKeyUpField($event)\" (focus)=\"onFocusMask()\" (blur)=\"onBlurMask()\" name=\"username\"\n  [attr.disabled]=\"isDisabledField ? '' : null\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/username-field/username-field.component.html
// module id = ./src/app/view/components/username-field/username-field.component.html
// module chunks = main